import Vue from "vue";

export default {
  async list() {
    const response = await Vue.axios.get("files");
    return response.data;
  },

  async get(id) {
    const response = await Vue.axios.get(`files/${id}`);
    return response.data;
  },

  async create(data) {
    const response = await Vue.axios.post("files", data);
    return response.data;
  },

  async update(id, data) {
    const response = await Vue.axios.put(`files/${id}`, data);
    return response.data;
  },

  async delete(id) {
    const response = await Vue.axios.delete(`files/${id}`);
    return response;
  }
};
